import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Container,
  Grid,
  Card,
  Typography,
  CircularProgress
} from "@mui/material";
import { collection, query, where, getDocs } from "firebase/firestore";
import { db } from "../../firebase";
import Home from "../servers/Home"; // adjust path if needed
import ServerOrder  from "../servers/Order"; // adjust path
export default function Order() {
  const navigate = useNavigate();
  const location = useLocation();

  const [servers, setServers] = useState([]);
  const [loading, setLoading] = useState(true);
const [selectedServer, setSelectedServer] = useState(null);
const [view, setView] = useState("list"); 
const [allowOrderPage, setAllowOrderPage] = useState(null);
const [orderContext, setOrderContext] = useState(null);
  const params = new URLSearchParams(location.search);

  const companyCode =
  location?.state?.companyCode ||
  new URLSearchParams(location.search).get("code") ||
  sessionStorage.getItem("companyCode") ||
  localStorage.getItem("companyCode") ||
  null;


const unitCode =
  location?.state?.unitCode ||
  new URLSearchParams(location.search).get("unit") ||
  sessionStorage.getItem("unitCode") ||
  localStorage.getItem("unitCode") ||
  null;

 /* useEffect(() => {
  const loggedInUserId =
    location?.state?.userId ||
    sessionStorage.getItem("userId") ||
    localStorage.getItem("userId");

  if (loggedInUserId) {
    sessionStorage.setItem("managerId", loggedInUserId);
    console.log(" Manager stored:", loggedInUserId);
  }
}, []);*/

useEffect(() => {
  const existingManager = sessionStorage.getItem("managerId");

  if (existingManager) {
    console.log("Manager already exists:", existingManager);
    return; //  stop overwrite
  }

  const loggedInUserId =
    location?.state?.userId ||
    sessionStorage.getItem("userId") ||
    localStorage.getItem("userId");

  if (loggedInUserId && loggedInUserId.includes("#manager")) {
    sessionStorage.setItem("managerId", loggedInUserId);
    console.log(" Manager stored:", loggedInUserId);
  }
}, []);
  useEffect(() => {
  const fetchPreference = async () => {
    if (!companyCode || !unitCode) return;

    try {
      const q = query(
        collection(db, "preferences"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("preferenceName", "==", "Billing Process") //  match DB
      );

      const snapshot = await getDocs(q);

      if (!snapshot.empty) {
        const data = snapshot.docs[0].data();

        console.log("Order Access Preference:", data.preferenceValue);

        //setAllowOrderPage(Number(data.preferenceValue) === 0);
        const pref = Number(data.preferenceValue);
setAllowOrderPage(pref === 0 || pref === 1 || pref === 2 || pref === 3); // allow if 0,1,2,3
      } else {
        setAllowOrderPage(true); // fallback
      }
    } catch (err) {
      console.error("Preference error:", err);
      setAllowOrderPage(true);
    }
  };

  fetchPreference();
}, [companyCode, unitCode]);

  /*useEffect(() => {
  const fetchActiveServer = async () => {
    if (!companyCode || !unitCode) return;

    try {
      //  1. Get active orders
      const orderQuery = query(
        collection(db, "orders"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("orderStatus", "==", "Open") 
      );

      const orderSnap = await getDocs(orderQuery);

      if (orderSnap.empty) {
        console.log("No active orders found");
        setView("list"); // fallback
        setLoading(false);
        return;
      }

      // 2. Extract waiterId
      const orderData = orderSnap.docs[0].data();
      const waiterId = orderData.waiterId;

      if (!waiterId) {
        console.log("No waiterId found in order");
        setView("list");
        setLoading(false);
        return;
      }

console.log("Matching waiterId:", waiterId);

      // 3. Fetch server from users
     const userQuery = query(
  collection(db, "users"),
  where("companyCode", "==", companyCode),
  where("unitCode", "==", unitCode),
  where("userId", "==", waiterId),
  where("role", "==", "servers")
);
      const userSnap = await getDocs(userQuery);

      if (!userSnap.empty) {
        const server = userSnap.docs[0].data();

        // Auto open Home
        setSelectedServer(server);
        setView("home");

        sessionStorage.setItem("companyCode", companyCode);
        sessionStorage.setItem("unitCode", unitCode);
        sessionStorage.setItem("userId", server.userId);
        sessionStorage.setItem("role", "servers");
         sessionStorage.removeItem("showPaid");
    sessionStorage.removeItem("showCancelled");
    sessionStorage.removeItem("showDeleted");
      } else {
        console.log("Server not found in users");
        setView("list");
      }
    } catch (err) {
      console.error("Error fetching active server:", err);
      setView("list");
    } finally {
      setLoading(false);
    }
  };

  fetchActiveServer();
}, [companyCode, unitCode]);*/

useEffect(() => {
  const fetchServerFlow = async () => {
    if (!companyCode || !unitCode) return;

    try {
      // 1. Try to get active order
      const orderQuery = query(
        collection(db, "orders"),
        where("companyCode", "==", companyCode),
        where("unitCode", "==", unitCode),
        where("orderStatus", "==", "Open")
      );

      const orderSnap = await getDocs(orderQuery);

      let server = null;

      // 2. If active order exists → use its waiter
      if (!orderSnap.empty) {
        const orderData = orderSnap.docs[0].data();
        const waiterId = orderData.waiterId;

        if (waiterId) {
          const userQuery = query(
            collection(db, "users"),
            where("companyCode", "==", companyCode),
            where("unitCode", "==", unitCode),
            where("userId", "==", waiterId),
            where("role", "==", "servers")
          );

          const userSnap = await getDocs(userQuery);

          if (!userSnap.empty) {
            server = userSnap.docs[0].data();
          }
        }
      }

      // 3. If NO active order → fallback to ANY server
      if (!server) {
        const serverQuery = query(
          collection(db, "users"),
          where("companyCode", "==", companyCode),
          where("unitCode", "==", unitCode),
          where("role", "==", "servers")
        );

        const serverSnap = await getDocs(serverQuery);

        if (!serverSnap.empty) {
          server = serverSnap.docs[0].data(); // pick first server
        }
      }

      // 4. If server found → go to Home
      if (server) {
        setSelectedServer(server);
        setView("home");

        sessionStorage.setItem("companyCode", companyCode);
        sessionStorage.setItem("unitCode", unitCode);
        //sessionStorage.setItem("userId", server.userId);
        sessionStorage.setItem("serverUserId", server.userId);
        sessionStorage.setItem("role", "servers");

        sessionStorage.removeItem("showPaid");
        sessionStorage.removeItem("showCancelled");
        sessionStorage.removeItem("showDeleted");
      } else {
        setView("list"); // no server at all
      }

    } catch (err) {
      console.error("Error:", err);
      setView("list");
    } finally {
      setLoading(false);
    }
  };

  fetchServerFlow();
}, [companyCode, unitCode]);

  //  Navigate on click
 const handleSelectServer = (server) => {
  setSelectedServer(server);
  setView("home");

  sessionStorage.setItem("companyCode", companyCode);
  sessionStorage.setItem("unitCode", unitCode);
  //sessionStorage.setItem("userId", server.userId);
  sessionStorage.setItem("serverUserId", server.userId);
  sessionStorage.setItem("role", "servers");
  sessionStorage.removeItem("showPaid");
    sessionStorage.removeItem("showCancelled");
    sessionStorage.removeItem("showDeleted");
};

if (selectedServer && view === "home") {
  return (
    <Home
      companyCode={companyCode}
      unitCode={unitCode}
      userId={selectedServer.userId}
      onBack={() => {
        setSelectedServer(null);
        setView("list");
      }}
      /*onOpenOrder={(data) => {
  setOrderContext(data);
  setView("order");
}}*/
onOpenOrder={(data) => {
  if (!allowOrderPage) {
    alert("Order page is disabled by preference");
    return;
  }

  setOrderContext(data);
  setView("order");
}}
    />
  );
}

if (selectedServer && view === "order") {
  if (!allowOrderPage) {
    return (
      <Container sx={{ mt: 4 }}>
        <Typography color="error">
          Order page is disabled by preference
        </Typography>
      </Container>
    );
  }

  return (
    <ServerOrder 
      companyCode={companyCode}
      unitCode={unitCode}
      //userId={selectedServer.userId}
      userId={sessionStorage.getItem("serverUserId")} // server
  managerId={sessionStorage.getItem("managerId")} // manager 
     
  isManagerRoute={true} // flag
      tableId={orderContext?.tableId}
      serviceArea={orderContext?.serviceArea}
      onBack={() => setView("home")}
    />
  );
}

  if (loading) {
    return (
      <Container sx={{ textAlign: "center", mt: 5 }}>
        <CircularProgress />
        <Typography sx={{ mt: 2 }}>Loading servers...</Typography>
      </Container>
    );
  }

}